import IValidationRule from "./ValidationRule";

export default class ValidationRuleEmail implements IValidationRule {
  private _message: string | undefined;

  public get message(): string | undefined {
    return this._message;
  }

  public check(value: any): boolean {
    this._message = undefined;

    if (value == null || (value + "").length === 0) {
      return true;
    }

    const regExp = /^[0-9a-zA-Z]([-_\\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;

    if (regExp.test(value) !== true) {
      this._message = `이메일주소 형식이 올바르지 않습니다.`;

      return false;
    }
    this._message = "";
    return true;
  }
}
